import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getRatingList(authorization, filter) {
  const url = `${API_URL}/admin/rating/list`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getRatingDetail(authorization, idRating) {
  const url = `${API_URL}/admin/rating/detail/${idRating}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getSurveyList(authorization, filter) {
  const url = `${API_URL}/admin/survey/list`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getSurveyDetail(authorization, idSurvey) {
  const url = `${API_URL}/admin/survey/detail/${idSurvey}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/ratingsurvey.js